import BaseMultipleSelectorV2 from "components/base/BaseMultipleSelectorV2";
import React, { useEffect, useState } from "react";
import CreateCategoryPrompt from "./CreateCategoryPrompt";
import { useDispatch, connect } from "react-redux";
import { useFormContext } from "react-hook-form";
import { PermissionCodes } from "config/PermissionCodes";
import { errorMessage, hasError } from "components/base/ErrorFieldMessage";

const mapPropsToState = (state) => ({
  campaignCategoryList: state.campaignCategoryList.notPagedAllList,
});

const CategorySelectorWithPrompt = ({
  campaignCategoryList,
  campaignCategoriesFieldName = "categories"
}) => {
  const dispatch = useDispatch();

  const { watch, setValue, formState: { errors } } = useFormContext();
  const selectedCategories = watch(campaignCategoriesFieldName) || [];
  const [showCreateCategory, setShowCreateCategory] = useState(false);

  useEffect(() => {
    dispatch({
      type: 'campaignCategoryList/getAllList',
      payload: { isAll: true },
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);
  return <>
    <BaseMultipleSelectorV2
      title={'Campaign category (optional)'}
      namespace={'campaignCategoryList'}
      data={{
        sourceData: campaignCategoryList,
        targetData: selectedCategories,
        targetChange: (value) => {
          setValue(campaignCategoriesFieldName, value, { shouldDirty: true })
        },
      }}
      addButton={{
        title: 'Add Campaign Category',
        action: () => {
          setShowCreateCategory(true);
        },
      }}
      error={{
        error: hasError(errors, campaignCategoriesFieldName),
        id: campaignCategoriesFieldName,
        message: errorMessage(errors, campaignCategoriesFieldName),
      }}
      requires={PermissionCodes.addCampaignCategory}
    />

    <CreateCategoryPrompt
      show={showCreateCategory}
      onClose={() => setShowCreateCategory(false)}
      successAction={(data) => {
        dispatch({
          type: 'campaignCategoryList/getAllList',
          payload: { isAll: true },
        });
        if (data) {
          setValue('categories', [...selectedCategories, data], {
            shouldDirty: true,
          });
        }
      }}
    />
  </>
}
export default connect(mapPropsToState)(CategorySelectorWithPrompt);
